export default class ProductPriceGroups {
  constructor($scope, ProductService, PaginationService) {
    $scope.load_data = function() {
      $scope.loading = true;
      ProductService.get_price_groups($scope.filter).success(function(data) {
        $scope.price_groups = data.price_groups;
        $scope.pagination = PaginationService.get_pagination(data.pagination);
        $scope.loading = false;
      });
    };

    $scope.load_groups = function() {
      ProductService.get_all_groups().success(function(data) {
        $scope.groups = data.groups;
      });
    };

    $scope.init_filters = function() {
      $scope.filter = {
        page: 1,
        per_page: 100,
        product_group_id: null,
        product_id: null
      };
    };

    $scope.get_page_data = function(page) {
      $scope.filter.page = page;
      $scope.load_data();
    };

    $scope.create_group = function() {
      $scope.creating = true;
      ProductService.create_price_group($scope.selected_group.id, $scope.group_title).success(function(data) {
        if (data.success) {
          $scope.group_title = null;
          $scope.show_create_group = false;
          $scope.load_data();
        }
      });
    };

    $scope.update_supplier_pricings = function(price_group) {
      price_group.updating_supplier_pricings = true;
      ProductService.update_price_group_supplier_pricings(price_group.id).success(function(data) {
        if (data.success)
          price_group.updating_supplier_pricings = false;
      });
    };

    $scope.update_buyer_pricings = function(price_group) {
      price_group.updating_buyer_pricings = true;
      ProductService.update_price_group_buyer_pricings(price_group.id).success(function(data) {
        if (data.success)
          price_group.updating_buyer_pricings = false;
      });
    };

    $scope.delete_price_group = function(price_group) {
      if (confirm('Are you sure you want to delete this price group and all related members and prices?')) {
        price_group.deleting = true;
        ProductService
          .delete_price_group(price_group.id)
          .success(function(/*data*/) {
            price_group.deleting = false;
            $scope.load_data();
          });
      }
    };

    $scope.quick_search = function() {
      window.filter_table('table.data', $scope.quick_filter);
    };

    $scope.$watch('filter.product_group_id', function() {
      if ($scope.filter && $scope.filter.product_group_id) {
        ProductService.get_products($scope.filter.product_group_id).then(function(data) {
          $scope.products = data.products;
        });
      } else {
        $scope.products = [];
      }
    });

    $scope.init = function() {
      $scope.price_groups = [];
      $scope.pagination = {};
      $scope.init_filters();
      $scope.load_data();
      $scope.load_groups();
    };

    $scope.init();
  }
}

ProductPriceGroups.$inject = ['$scope', 'ProductService', 'PaginationService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/product-price-groups.ctrl.js